<app-detail [title]="title" [params]="detailParams"></app-detail>
